export default __webpack_public_path__ + "static/media/react.85300d32.svg";